import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { DemolitionPermitRoutingModule } from './demolition-permit-routing.module';
import { DPNewRequestComponent } from './new-request/new-request.component';
import { DPNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [DPNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    DemolitionPermitRoutingModule,
  ],
  providers: [DPNewRequestFormService],
})
export class DemolitionPermitModule {}
